<template>
    <div class="switch-field">

      <input
        :disabled="disabled"
        type="radio"
        :id="first.name"
        name="operandtype"
        :value="first.name"
        v-on:change="onChange"
        :checked="selected == first.name" />
      <label
        :for="first.name">
        {{ first.label }}
      </label>
      <input
        :disabled="disabled"
        type="radio"
        :id="second.name"
        name="operandtype"
        v-on:change="onChange"
        :value="second.name"
        :checked="selected == second.name" />
      <label
        :for="second.name">
        {{ second.label }}
      </label>
    </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    first: {
      type: Object,
      default: () => ({name: 'off', label: 'Off'})
    },
    second: {
      type: Object,
      default: () => ({name: 'on', label: 'On'})
    },
    selected: {
      type: String,
      default: 'off'
    },
    disabled: {
      type: Boolean,
      defatul: false
    }
  },
  methods: {
    onChange (event) {
      this.$emit('change', event);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  .switch-field {
    overflow: hidden;
  }

  .switch-field input {
    position: absolute !important;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    width: 1px;
    border: 0;
    overflow: hidden;
  }

  .switch-field label {
    font-size: 0.8em;
    float: left;
  }

  .switch-field label {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    background-color: $white;
    color: $black-trans6;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition:    all 0.1s ease-in-out;
    -ms-transition:     all 0.1s ease-in-out;
    -o-transition:      all 0.1s ease-in-out;
    transition:         all 0.1s ease-in-out;
  }

  .switch-field label:hover {
    cursor: pointer;
  }

  .switch-field input[type="radio"]:checked + label {
    background-color: $primary;
    color: $white;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .switch-field label:first-of-type {
    border-radius: $radius 0 0 $radius;
  }

  .switch-field label:last-of-type {
    border-radius: 0 $radius $radius 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/forms/ToggleSwitch.vue